// +----------------------------------------------------------------------
// | 首页输入框：一个大输入框 + 「帮我想想」按钮
// +----------------------------------------------------------------------
import { useEffect, useRef } from 'react';
import './DecisionInput.less';

const MAX_LENGTH = 300;

export default function DecisionInput({
  value,
  onChange,
  onSubmit,
  loading = false,
  placeholder = '周末不知道去哪……',
  buttonText = '帮我想想',
  autoFocus = false,
}) {
  const ref = useRef(null);

  useEffect(() => {
    if (autoFocus && ref.current) {
      ref.current.focus();
    }
  }, [autoFocus]);

  const handleKeyDown = (e) => {
    // Enter 直接提交，Shift+Enter 换行
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    const text = (value || '').trim();
    if (!text || loading) return;
    onSubmit(text);
  };

  const remain = MAX_LENGTH - (value || '').length;

  return (
    <div className="decision-input">
      <textarea
        ref={ref}
        className="decision-input-box"
        value={value}
        onChange={(e) => onChange(e.target.value.slice(0, MAX_LENGTH))}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        rows={3}
        maxLength={MAX_LENGTH}
      />

      <div className="decision-input-foot">
        <span className={`decision-input-count ${remain <= 20 ? 'is-warn' : ''}`}>
          {remain}
        </span>

        <button
          type="button"
          className="btn btn-primary decision-input-btn"
          onClick={handleSubmit}
          disabled={loading || !(value || '').trim()}
        >
          {loading ? '正在想…' : buttonText}
        </button>
      </div>
    </div>
  );
}
